import { object, string } from "yup";
import { FormikProps, FormikActions } from "formik";

import { FeedbackType } from "../../../utils/makeReportIssue";
import { reduceFieldSettings } from "../../../utils/reduceFieldSettings";

const ISSUE_TYPES = Object.values(FeedbackType);

const list: Array<any> = [
  {
    name: "type",
    initValue: "",
    placeholder: "Type of feedback",
    validationRule: string()
      .oneOf(ISSUE_TYPES, "Type is not allow.")
      .required("Type is required."),
  },
  {
    name: "message",
    initValue: "",
    placeholder: "Tell us more about your issue...",
    validationRule: string()
      .required("Message is required."),
  },
  {
    name: "files",
    initValue: [],
  },
  {
    name: "email",
    type: "email",
    initValue: "",
    placeholder: "Email",
    validationRule: string()
      .email("Not valid email.")
      .required("Email is required."),
  },
];

const { initialValues, fields, validationRuleObject } = reduceFieldSettings(list);

const validationSchema = object().shape(validationRuleObject);

const options = ISSUE_TYPES.map(item => ({ value: item, label: item, }));

export type ValueTypes = typeof initialValues;

export type FormTypes = FormikProps<ValueTypes>;

export type FormActionTypes = FormikActions<ValueTypes>;

export {
  fields,
  initialValues,
  options,
  validationSchema,
};
